import {
  Component,
  HostBinding,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
} from '@ngx-formly/core';
import { Table } from 'primeng/table';
import { FormGeneratorComponent } from '../../form-generator';
import {
  decodeBase64FromDataURL,
  decompressAndDecodeData,
  getRandomUID,
} from '../../../../utils';

@Component({
  selector: 'form-formeditor-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-formeditor-field {
        display: flex;
        flex-direction: column;
        flex: 1;
        .file-label {
          pointer-events: none;
          top: var(--p-iftalabel-top);
          transition-property: all;
          transition-timing-function: ease;
          line-height: 1;
          font-size: var(--p-iftalabel-font-size);
          font-weight: var(--p-iftalabel-font-weight);
          inset-inline-start: var(--p-iftalabel-position-x);
          color: var(--p-iftalabel-color);
          transition-duration: var(--p-iftalabel-transition-duration);
          margin-bottom: 0.7rem;
        }
        .p-fileupload-basic {
          justify-content: flex-start;
        }
      }
    `,
  ],
  template: `
    <input type="hidden" [formControl]="formControl" />
    <div>
      <div *ngIf="field.props.label" class="file-label">
        {{
          field.props['translate']
            ? (field.props.label | translate)
            : field.props.label
        }}
      </div>

      <div class="flex flex-wrap items-center content-center gap-2">
        <p-button
          class="button--only-disabled-form"
          (click)="showDialog(true)"
          [label]="'formsCommon.editor.action.show' | translate"
        />
        <p-button
          (click)="showDialog()"
          [label]="'formsCommon.editor.action.edit' | translate"
        />
        <p-button
          *ngIf="hasFileSelected()"
          [label]="'formsCommon.editor.action.delete' | translate"
          icon="pi pi-trash"
          (click)="deleteFile()"
        />
      </div>

      <p-dialog
        *ngIf="visibleReadOnly"
        [header]="'formsCommon.editor.title' | translate"
        [modal]="true"
        [(visible)]="visibleReadOnly"
        [appendTo]="'body'"
      >
        <form-generator
          #formGenerator
          [hideNavigation]="true"
          [isModal]="true"
          [fieldsRaw]="fieldsRaw"
          style="min-height: 71vh;max-height: 71vh; overflow-y: auto;"
        ></form-generator>
        <div class="flex flex-1">
          <div class="flex flex-1 pt-6 gap-4">
            <p-button
              (click)="onExportFormFile()"
              [label]="'formsCommon.editor.action.export' | translate"
              icon="pi pi-download"
              iconPos="left"
            />
          </div>
          <div class="flex">
            <div class="flex justify-end pt-6 gap-4">
              <p-button
                [label]="'formsCommon.editor.action.close' | translate"
                severity="secondary"
                (click)="closeDialog()"
              />
            </div>
          </div>
        </div>
      </p-dialog>

      <p-dialog
        *ngIf="visible"
        [header]="'formsCommon.editor.title' | translate"
        [modal]="true"
        [(visible)]="visible"
        [appendTo]="'body'"
      >
        <form-generator
          #formGenerator
          [hideNavigation]="true"
          [isModal]="true"
          [fieldsRaw]="fieldsRaw"
          style="min-height: 74vh;max-height: 74vh; overflow-y: auto;"
        ></form-generator>
        <div class="flex flex-1">
          <div class="flex flex-1 pt-6 gap-4">
            <p-fileupload
              mode="basic"
              name="demo[]"
              chooseIcon="pi pi-upload"
              accept="application/json"
              maxFileSize="1000000"
              (onSelect)="onSelectImportFormFile($event)"
              [auto]="true"
              [chooseLabel]="'formsCommon.editor.action.import' | translate"
            />
            <p-button
              (click)="onExportFormFile()"
              [label]="'formsCommon.editor.action.export' | translate"
              icon="pi pi-download"
              iconPos="left"
            />
          </div>
          <div class="flex">
            <div class="flex justify-end pt-6 gap-4">
              <p-button
                [label]="'formsCommon.editor.action.close' | translate"
                severity="secondary"
                (click)="closeDialog()"
              />
              <p-button
                [label]="'formsCommon.editor.action.save' | translate"
                (click)="onSave()"
              />
            </div>
          </div>
        </div>
      </p-dialog>
    </div>
  `,
})
export class FormFormeditorFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-formeditor-field';

  fieldsRaw: FormlyFieldConfig[] = this.getDefaultFieldsRaw();
  visible = false;
  visibleReadOnly = false;

  @ViewChild('formGenerator') formGenerator?: FormGeneratorComponent;

  showDialog(readOnly = false): void {
    console.log(this.formControl.getRawValue());
    const rawValue = this.formControl.getRawValue();
    if (!this.formControl.getRawValue()) {
      this.fieldsRaw = this.getDefaultFieldsRaw();
    } else {
      // const positionStart = rawValue.indexOf('base64,') + 7;
      const formData = JSON.parse(decodeBase64FromDataURL(rawValue));
      console.log(formData);
      this.fieldsRaw = formData.fields;
    }

    if (readOnly) {
      this.visibleReadOnly = true;
    } else {
      this.visible = true;
    }
  }
  deleteFile(): void {
    this.formControl.setValue(undefined);
  }

  hasFileSelected(): boolean {
    return !!this.formControl.getRawValue();
  }

  onSelectImportFormFile(event: any): void {
    if (!this.formGenerator) {
      return;
    }
    this.formGenerator.onSelectImportFormFile(event);
  }
  onExportFormFile(): void {
    if (!this.formGenerator) {
      return;
    }
    this.formGenerator.onExportFormFile();
  }
  closeDialog(): void {
    this.visible = false;
    this.visibleReadOnly = false;
  }
  onSave(): void {
    if (!this.formGenerator) {
      return;
    }
    // Check if valid
    console.log(this.formGenerator);

    this.fieldsRaw = this.formGenerator.fieldsRaw;
    console.log(this.fieldsRaw);
    this.formControl.setValue(
      `filename:Zm9ybS5qc29u;data:application/json;base64,${btoa(
        JSON.stringify({
          fields: this.fieldsRaw,
        }),
      )}`,
    );
    this.visible = false;
  }

  getDefaultFieldsRaw(): FormlyFieldConfig[] {
    return [
      {
        id: 'root-wrapper-' + getRandomUID(false, true),
        wrappers: ['root'],
        fieldGroup: [],
      },
    ];
  }
}
